import { Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UiService } from 'app/core/services/ui.service';
import { AccessType } from '@classes/access-type';
import { AccessTypeService } from 'app/core/services/access-type.service';

@Component({
  selector: 'app-access-type-detail',
  templateUrl: './access-type-detail.component.html',
  styleUrls: ['./access-type-detail.component.scss']
})
export class AccessTypeDetailComponent implements OnInit {

  accessTypeForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AccessTypeDetailComponent>,
    private accessTypeService: AccessTypeService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: AccessType
  ) { }

  ngOnInit() {
    this.initFormBuilder();
  }
  private initFormBuilder() {
    const fb = this.formBuilder;
    const accessTypeForm = this.accessTypeForm = fb.group({
      id: fb.control(this.data?.id),
      name: fb.control(this.data?.name, [Validators.required, Validators.maxLength(50)]),
    });
  }
  onSubmit() {
    const accessType = new AccessType(
      this.accessTypeForm.value
    )
    this.uiService.addRouteLoading();
    this.accessTypeService.createOrUpdateAccessType(accessType).subscribe(data => {
      this.dialogRef.close(true);
      this.uiService.displayMessageToast('access-type.success-edit');
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }

}
